import type { taskEither } from "fp-ts";

import type { ChangePassword, Common, Login, Register, ResetPassword } from "./ios";

import type { UserEntity } from "~/entities/user/@x/auth";
import type {
  AuthenticationError,
  AuthorizationError,
  NotFoundError,
  UnexpectedError,
  UniqueKeyViolationError,
} from "~/shared/error";

abstract class Provider {
  abstract register(
    params: Register.In,
  ): taskEither.TaskEither<
    UnexpectedError | UniqueKeyViolationError<UserEntity.Constraint>,
    Common.Out
  >;
  abstract login(
    params: Login.In,
  ): taskEither.TaskEither<UnexpectedError | NotFoundError, Common.Out>;
  abstract logout(): taskEither.TaskEither<UnexpectedError | AuthenticationError, void>;
  abstract changePassword(
    params: ChangePassword.In,
  ): taskEither.TaskEither<
    | UnexpectedError
    | AuthenticationError
    | AuthorizationError
    | NotFoundError
    | ChangePassword.Error,
    void
  >;
  abstract resetPassword(
    params: ResetPassword.In,
  ): taskEither.TaskEither<UnexpectedError | NotFoundError, void>;
  abstract getMe(): taskEither.TaskEither<UnexpectedError | AuthenticationError, Common.Out>;
}

export { Provider };
